import React, { useContext, useState } from 'react';
import styled, { ThemeContext, css } from 'styled-components';
import media from '../../utils/media';
import { ComponentHeader } from '../ComponentWrappers';
import { P3 } from '../Typography';
import { isFieldValid } from '../../utils/validation';
import { CardGridItem } from './CardGridItem';
import { COMPONENT_MARGIN_BOTTOM } from '../../constants';
import { UnstyledButton } from '../Buttons';
import { defineRegionFieldFromTitle, defineAriaLabelFromTitle } from '../../utils/helpers';
export const Container = styled.div `
  outline: none;
  margin-top: ${({ hasNegativeMarginTop }) => hasNegativeMarginTop ? `calc(-30px - ${COMPONENT_MARGIN_BOTTOM.DESKTOP}px)` : ''};
  position: relative;
  width: 100%;
  height: auto;
  background: transparent;
  justify-content: center;
  align-items: center;
  padding-bottom: ${`${COMPONENT_MARGIN_BOTTOM.DESKTOP}px`};
  ${media.mobile} {
    margin-top: ${({ hasNegativeMarginTop }) => hasNegativeMarginTop ? `calc(-30px - ${COMPONENT_MARGIN_BOTTOM.MOBILE}px)` : ''};
    width: 100%;
    display: grid;
    padding-bottom: ${`${COMPONENT_MARGIN_BOTTOM.MOBILE}px`};
  }
`;
const Background = styled.div `
  background: ${({ theme }) => theme.greyLight};
  top: ${({ hasNegativeMarginTop }) => (hasNegativeMarginTop ? `30px` : `0px`)};
  position: absolute;
  z-index: -1;
  height: 100%;
  width: 100%;
`;
const CardsContainer = styled.div `
  width: 1110px;
  margin: 0 auto;
  display: flex;
  flex-wrap: wrap;
  @media (max-width: 1139px) {
    width: 730px;
  }
  ${media.mobile}  {
    width: auto;
    margin-right: 15px;
    margin-left: 15px;
  }
`;
const CardContainer = styled.div `
  background: ${({ theme }) => theme.primaryWhite};
  vertical-align: top;
  margin-right: 30px;
  width: 350px;
  min-height: 500px;
  ${({ length }) => length === 2
    ? css `
          width: 540px;
          min-height: 470px;
          &:nth-of-type(2n) {
            margin-right: 0;
          }
        `
    : css `
          width: 350px;
          min-height: 500px;
          &:nth-of-type(3n) {
            margin-right: 0;
          }
        `}
  }

  margin-bottom: 30px;
  @media (max-width: 1139px) {
    width: 350px;
    min-height: 500px;
    &:nth-of-type(3n) {
        margin-right: 30px;
      }
      &:nth-of-type(2n) {
        margin-right: 0;
      }
  }
  ${media.mobile} {
    width: 100%;
    margin-right: 0;
    min-height: 470px;
    &:nth-of-type(3n) {
      margin-right: 0;
    }
  }
  @media (max-width: 580px) {
    min-height: 443px;
  }
`;
const LoadMoreContainer = styled.div `
  text-align: center;
  margin-top: 20px;
`;
const LoadMore = styled(UnstyledButton) `
  width: 200px;
  height: 44px;
  border: 2px solid #dc2440;
  background: ${({ theme }) => theme.primaryWhite};
`;
const LoadMoreText = styled(P3) `
  line-height: 20px;
`;
const CardGridContainer = ({ fields }) => {
    if (!fields) {
        console.warn('CardGridContainer component requires fields to be provided');
        return null;
    }
    const { loadMoreLabel, componentTitle, componentSubtitle, componentNegativeMargin, items, ariaLabel, } = fields;
    const { isWindowMobile } = useContext(ThemeContext);
    const [itemsToShow, setItemsToShow] = useState(isWindowMobile ? 6 : 9);
    const [expanded, setExpanded] = useState(false);
    const margin = componentNegativeMargin && componentNegativeMargin.value;
    const hasComponentHeader = isFieldValid(componentTitle);
    const length = items && items.length;
    const cardGridItems = items &&
        items.slice(0, itemsToShow).map((card, key) => {
            const { fields } = card;
            return (React.createElement(CardContainer, { length: length },
                React.createElement(CardGridItem, { key: key, fields: fields })));
        });
    function loadMoreClick() {
        const increaseBy = isWindowMobile ? 6 : 9;
        let newTotal = increaseBy + itemsToShow;
        if (newTotal > items.length) {
            setItemsToShow(items.length);
            setExpanded(true);
        }
        else {
            setItemsToShow(newTotal);
        }
    }
    return (React.createElement(Container, { hasNegativeMarginTop: !hasComponentHeader && margin, role: defineRegionFieldFromTitle(componentTitle), "aria-label": defineAriaLabelFromTitle(componentTitle, ariaLabel) },
        React.createElement(Background, { hasNegativeMarginTop: !hasComponentHeader && margin }),
        React.createElement(ComponentHeader, { title: hasComponentHeader && componentTitle, subtitle: hasComponentHeader && componentSubtitle, ariaLabel: ariaLabel },
            React.createElement(CardsContainer, null, cardGridItems),
            React.createElement(LoadMoreContainer, null, (isWindowMobile && expanded === false && items.length > 6) ||
                (!isWindowMobile && expanded === false && items.length > 9) ? (React.createElement(LoadMore, { onClick: loadMoreClick },
                React.createElement(LoadMoreText, { field: loadMoreLabel }))) : null))));
};
export default CardGridContainer;
